import FrontBusiness from "@/business/FrontBusiness";
import Http from "@/commons/Http";

const path = 'api/indicador-real-externo';

export default {

  async pagination(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/pagination?sort=${sort || 'ire.codigo'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async paginationV2(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/v2/pagination?sort=${sort || 'ire.codigo'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async getById(id){
    return Http.get(`${path}/${id}`);
  },

  async delete(id){
    return Http.delete(`${path}/${id}`);
  },

  async buscarProtocolos(id){
    return Http.get(`${path}/${id}/protocolos`);
  },

  async buscarProtocolosAtivos(id, protocolo = null){
    let params = new URLSearchParams();

    if(protocolo) {
      params.append('protocolo', protocolo);
    }

    return Http.get(`${path}/${id}/protocolos-ativos`, {params});
  },

  async listarRegistros(id, sort, direction){
    return Http.get(`${path}/${id}/registros?sort=${sort || 'ordem'},${direction || 'asc'}`);
  },

  async ordenarRegistros(id, unidades) {
    return Http.post(`${path}/${id}/registros/ordenar`, unidades);
  },

  nomearFicha(ficha = {}, codigo = true){
    let livro = FrontBusiness.nomearLivro(ficha.tipo) + ' ';
    let letra = '';
    if (ficha.livroLetra && /^[a-zA-Z0-9]+$/.test(ficha.livroLetra)) {
      letra = '-' + ficha.livroLetra;
    }
    return `${livro}${codigo ? FrontBusiness.formatarCodigo(ficha.codigo) : ''}${letra}`.trim();
  },

  async getFichasPorCodigo(params = {}) {
    const {livro, dto} = params;
    return await Http.post(`${path}/codigos/${livro}`, dto);
  },

  exportarRegistrosPosteriores(id, direction) {
    return `${path}/${id}/exportar-registros-posteriores?sort=codigo,${direction || 'desc'}`;
  },

  async verificarDuplicidade(dto, id) {
    return Http.post(`${path}/verificar-duplicidade/${id || ''}`, dto);
  },

  async saveImportacao(origemId, file) {
    const formData = new FormData();
    formData.append("file", file);
    let config = { timeout: 0, headers: { 'Content-Type': 'multipart/form-data' } };
    return Http.post(`${path}/lote-importacao/${origemId}`, formData, config);
  },

  async uploadPlanilha(file, indicadorRealExternoId, configuracao) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("configuracao", new Blob([JSON.stringify(configuracao)], { type: "application/json" }));
    let config = { timeout: 0, headers: { 'Content-Type': undefined } };
    return Http.post(`${path}/${indicadorRealExternoId}/unidade/upload-planilha`, formData, config);
  },

  async previewPlanilha(file, indicadorRealExternoId, configuracao) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("configuracao", new Blob([JSON.stringify(configuracao)], { type: "application/json" }));
    let config = { timeout: 0, headers: { 'Content-Type': undefined } };
    return Http.post(`${path}/${indicadorRealExternoId}/unidade/preview/upload-planilha`, formData, config);
  },

  getErrosForm(form) {
    let validation = {};
    let invalid = false;
    if (!form.serventia) {
      validation.serventia = 'O campo serventia é obrigatório';
      invalid = true;
    }
    if (!form.tipo) {
      validation.tipo = 'O campo tipo é obrigatório';
      invalid = true;
    }
    if (!form.codigo) {
      validation.codigo = 'O campo código é obrigatório';
      invalid = true;
    }
    return invalid ? validation : undefined;

  },
}
